
let filter_top_arrows = $('.collection-top-filters .filter-items__title');

if(filter_top_arrows.length){
    filter_top_arrows.each((key,item)=>{
        console.log(item)
        $(item).on('click', ()=>{
            $(item).closest('.filter-items').toggleClass('active');
            
        })
    })
}

let filter_top_inputs = $('.collection-top-filters li input:not(disabled)');

if(filter_top_inputs.length){
    filter_top_inputs.each((key,item)=>{
        $(item).on('click', ()=>{
            $('.collection-top-filters form').submit()
        })
    })
}


let filter_mobile_button = document.querySelectorAll('.filter-mobile__wrapper:not(.color) .filter-mobile__header');


if(filter_mobile_button.length){
  filter_mobile_button.forEach((item,key)=>{
    item.addEventListener('click', (e)=>{
      item.classList.toggle("active");
    })
  })
}